import { cache } from '@/container/apollo-client/cache';
import { QUERY_GET_NOTIFICATIONS } from '@/graphql/cursor.graphql';
import { QUERY_GET_NOTIFICATION_COUNT } from '@/graphql/query.graphql';
import {
  GetAllNotificationV2Query,
  NotificationV2,
  ObtainNotificationCountQuery,
  useMarkAllAsSeenNotificationMutation,
} from '@/types/generated/graphql';

export function useMarkAllSeen() {
  const [markAllAsSeen, { loading }] = useMarkAllAsSeenNotificationMutation({
    onCompleted: updateSeenNotificationCache,
  });

  // get triggered one time,
  // after closing notification to show unseen notification
  // to solve this backend needs to do this without notificationId which they say is IMPOSSIBLE
  // SO DEAL WITH IT (;_;)

  function markAllSeenHandler(firstNotificationId?: NotificationV2['id']) {
    if (!firstNotificationId) return;
    const notificationCount = cache.readQuery<ObtainNotificationCountQuery>({ query: QUERY_GET_NOTIFICATION_COUNT });
    if (notificationCount?.obtainNotificationCount?.data?.count > 0) {
      markAllAsSeen({
        variables: {
          notificationId: firstNotificationId,
        },
      });
    }
  }

  function updateSeenNotificationCache() {
    cache.updateQuery<GetAllNotificationV2Query>({ query: QUERY_GET_NOTIFICATIONS }, (data) => {
      if (!data) return data;
      const notificationList = data.getAllNotificationV2?.data || [];
      const now = new Date().toISOString();
      const updated = notificationList.map((item) => ({
        ...item,
        seenAt: item?.seenAt === null ? now : item?.seenAt,
      }));
      return {
        ...data,
        getAllNotificationV2: {
          ...data.getAllNotificationV2,
          data: updated,
        },
      };
    });
  }

  return {
    markAllSeenHandler,
    loading,
  };
}
